import React from "react";
import TicketHeader from "../Support/TicketHeader";
import ReportForm from "./ReportForm";
import { ApiHook } from "../../hooks/apiHook";

const CreateReport = () => {
    const partials = ApiHook.CallReportPartials();

    return (
        <>
            <TicketHeader />
            <ReportForm partials={partials.data} />
        </>
    );
};

export default CreateReport;
